export const addressLadSelectorProps = () => ({
  adressesLad: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  adressesLadEligible: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  magasinName: {
    type: String,
    required: true
  },
  selectedAddress: {
    type: Object,
    required: false,
    default: null
  },
  canAdd: {
    type: Boolean,
    required: false,
    default: false
  },
  checkEligibilite: {
    type: Boolean,
    required: false,
    default: true
  }
});

export const addressLadSelectorEmits = () => ([
  "adressSelected",
  "adressRnvpCheck",
  "resetAdress",
  "addAddress",
  "editAddress"
]);

export const useAdressLadSelector = (props, context) => {
  const selectedAdressId = ref(null);
  const defaultAddress = computed(() => {
    return props.adressesLad.find((address) => {
      return address.attributes.defaut &&
        props.adressesLadEligible.find(addressMagasin => address.id === addressMagasin.id) != null;
    });
  });
  const otherAddresses = computed(() => {
    return props.adressesLad.filter((address) => {
      return !address.attributes.defaut &&
        props.adressesLadEligible.find(addressMagasin => address.id === addressMagasin.id) != null;
    });
  });
  const unavalaibleAddresses = computed(() => {
    return props.adressesLad.filter((address) => {
      return props.adressesLadEligible.find(addressMagasin => address.id === addressMagasin.id) == null;
    });
  });
  const adressSelected = () => {
    const selected = props.adressesLad.find(address => address.id === selectedAdressId.value);
    if (selected.attributes.normalisee || selected.attributes.normalisation_proposee) {
      context.emit("adressSelected", selected);
    } else {
      context.emit("adressRnvpCheck", selected);
    }
  };
  const resetAdress = () => {
    selectedAdressId.value = null;
    context.emit('resetAdress');
  };
  const addAddress = () => {
    context.emit('addAddress');
  };
  const editAddress = (id) => {
    context.emit('editAddress', id);
  };

  return {
    selectedAdressId,
    defaultAddress,
    otherAddresses,
    unavalaibleAddresses,
    adressSelected,
    resetAdress,
    addAddress,
    editAddress
  }
}